export const linkifyOptions = {
  target: '_blank',
  defaultProtocol: 'https',
  rel: 'noopener noreferrer',
  truncate: 50,
};
